import React from 'react';

import PropTypes from 'prop-types';
import { faChevronRight } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Breadcrumbs } from '../../../../../shared/components/Breadcrumbs';
import { FilterButton } from '../../../../../shared/components/Filter';
import { CALENDAR_VIEWS, FILTERS } from '../../../constants';
import { useFilters } from '../../../hooks';
import { formatMonthYear, formatWeekRange } from '../../../utils';
import DateNav from './DateNav';
import ViewToggle from './ViewToggle';

const Header = ({ currentDate, currentView, onDateChange, onDateReset }) => {
  const { activeFilters, clearFilters } = useFilters();

  const dateRange =
    currentView === CALENDAR_VIEWS.MONTH.value
      ? formatMonthYear(currentDate)
      : formatWeekRange(currentDate);

  return (
    <div className="flex items-center justify-between p-2 border-b">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="-mr-1.5" />
        <Separator className="data-[orientation=vertical]:h-4" orientation="vertical" />
        <Breadcrumbs />
        <FontAwesomeIcon icon={faChevronRight} size="xs" />
        <span className="font-bold">{dateRange}</span>
      </div>

      <div className="flex items-center gap-2">
        <DateNav onDateChange={onDateChange} onDateReset={onDateReset} />
        <ViewToggle />

        <FilterButton
          activeFilters={activeFilters}
          clearFilters={clearFilters}
          filters={FILTERS}
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  currentDate: PropTypes.instanceOf(Date).isRequired,
  currentView: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onDateReset: PropTypes.func.isRequired,
};

export default Header;
